<template>
    <div class='wrap'>
        <div class='head'>
            <p class="headOne">
                PROFESSIONAL INTERNET SOLUTION<br>
                PROVIDER IN HEALTH & MEDICAL DOMAIN
            </p>
            <p class='headThree'>
                中国专业的<br>
                互联网医院+全链解决方案供应商
            </p>
            <img class='videoStart' src='./../../assets/Pc/banner1.png'>
            <p @click='look' class='look'>点击查看</p>
        </div>
        
        <div class='titleBox'>
            智慧医疗  无缝互联
            <img class='down' src="./../../assets/Mobile/Boao/downL.gif" alt="">
        </div>
        <div class='titleBoxTwo'>
            <p class='titleOne'>TELEMEDICINE SYSTEM</p>
            <p class='titleTwo'>远程医疗系统</p>
        </div>
         <div class='content'>
            中卫佰医自主开发的远程医疗平台，依托大型综合医疗机构或医
            学中心，整合区域内各级医疗机构的医疗资源，实现各医疗机构
            和各级医生上下联通，帮扶医疗资源相对较弱的地市级医院、县
            医院、乡镇医院、村医院，提高整体诊疗能力。
        </div>
        <div class='titleBoxTwo'>
            <p class='titleOne'>INTERNET HOSPITAL SYSTEM</p>
            <p class='titleTwo'>互联网医疗系统</p>
        </div>
         <div class='content'>
            中卫佰医互联网医院系统功能全面，细节契合医院需求，使用流
            程顺畅，方便患者接受并便捷使用。同时，系统在将现有诊疗流
            程互联网化的基础上，不断增加针对各病种的数据化随访功能，
            增加并不断深化医疗的人工智能，为互联网医院的线上与线下运
            营创造便利。
        </div>
        <div class='titleBox'>
            系统性解决方案
            <img class='down' src="./../../assets/Mobile/Boao/downL.gif" alt="">
        </div>
        <div class="imgBox">
            <ul>
                <li :style="'background:url('+ item.src +') no-repeat'" v-for="(item, index) in imgList" :key='index'>
                    <p class='imgBoxText'>{{item.text}}</p>
                </li>
            </ul>
            <p class="posAbso">INTRODCTION</p>
        </div>
        <div class='titleBox'>
            战略合作伙伴
            <img class='down' src="./../../assets/Mobile/Boao/downL.gif" alt="">
        </div>
        <ImgArr></ImgArr>
    </div>
</template>
<script>
    import ImgArr from '@/components/Mobile/ImgList.vue'
    export default {
        components: {
            ImgArr
        },
        data(){
            return {
                imgList: [
                    {
                        src: require('./../../assets/Pc/sys_one.png'),
                        text: '5G环境部署'
                    },
                    {
                        src: require('./../../assets/Pc/sys_two.png'),
                        text: '系统建设'
                    },
                    {
                        src: require('./../../assets/Pc/sys_three.png'),
                        text: '医疗资源'
                    },
                    {
                        src: require('./../../assets/Pc/sys_four.png'),
                        text: '专业运营'
                    },
                    {
                        src: require('./../../assets/Pc/sys_three.png'),
                        text: '金融支持'
                    }
                ],

            }
        },
        methods: {
            look(){
                console.log('点击')
                this.$router.push({path:'/mobileIndex/mobileSolution'})
            }
        }
    }
</script>
<style lang="less" scoped>
.head {
    width: 100%;
    height: 413px;
    background: url('./../../assets/Mobile/solution/solutionHead.png') no-repeat;
    background-size: 100% 100%;
    background-color:linear-gradient(128deg,rgba(59,167,234,1),rgba(59,78,222,1),rgba(59,78,222,1));
    font-family:NotoSansHans-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    text-align: left;
    padding-top: 70px;
    margin-bottom:20px;
    position: relative;
    .headOne{
        margin-bottom:20px;
        font-size:18px;
        font-family:PangMenZhengDao;
        font-weight:400;
        color:#CECECE;
        padding-left: 20px;
        line-height:36px;
        transform: scale(0.9) translateX(-38px);
    text-align: left
    }
    .headThree{
        padding-left: 20px;
        font-family: MicrosoftYaHei-Bold;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:48px;
        font-size:24px;
    }
    .videoStart{
        position: absolute; right: 10px; top: 7px;
        width:504px;
    }
    .look{
        width:142px;
        line-height: 37px;
        height:37px;
        margin:30px 0 0 20px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(255,255,255,1);
        border-radius:19px;
        font-size:18px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(62,106,229,1);
        text-align:center;
    }
}
// 标题
.titleBox{
    font-size:28px;
    font-family:NotoSansHans-Medium;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:36px; 
    text-align:center;
    // margin-bottom:34px;
    .down{
        width: 46px; display: block; margin:30px auto 60px; 
    }
}
.titleBoxTwo{
    text-align:center;
    margin-bottom:50px;
    .titleOne{
        font-size:24px;
        font-family:PangMenZhengDao;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:30px;
        background:linear-gradient(176deg,rgba(61,170,246,1) 7.5439453125%, rgba(174,195,255,1) 99.5849609375%);
        -webkit-background-clip:text;
        -webkit-text-fill-color:transparent;
        margin-bottom:12px;
    }
    .titleTwo{
        font-size:24px;
        font-family:NotoSansHans-Bold;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:30px;
    }
}
.onLineTitle{
    font-size:24px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:32px;
    text-align:center; margin-bottom: 52px;
}
// 图片
.centerImg{
    width: 713px; margin: 0 auto; display: block; margin-bottom:47px;
}
// 内容
.content{
    width: 716px;
    font-size:24px;
    font-family:NotoSansHans-Regular;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:36px;
    padding: 23px 26px; margin: 0 auto;
    background:rgba(255,255,255,1);
    box-shadow:6px 8px 60px 2px rgba(158,183,216,0.19);
    border-radius:10px;
    margin-bottom:46px;
}
// 系统解决性方案
.imgBox{
    width: 95%; margin: 0 auto 70px; position: relative; height: 150px;
    ul{
    display: flex; 
    justify-content: space-between;position: absolute; left: 0; top:0; width: 100%;height: 100%;
        li{
            width:135px; height: 100%; background-size:100% 100%!important;
            box-shadow:0px 5px 30px 2px rgba(32,110,216,0.08);
            opacity:0.92;background-color: white !important;
            border-radius:4px;
        }
        .imgBoxText{
            font-size:20px;
            font-family:NotoSansHans-Medium;
            font-weight:500;
            color:rgba(255,255,255,1);
            line-height:18px;
            text-align:center;
            padding-top: 90%;
            transform: scale(0.9)
        }
    }
    .posAbso{
        position: absolute; left: 0; bottom: -14px;font-size:51px;
        font-family:PangMenZhengDao;
        font-weight:400;
        color:rgba(47,161,255,1);
        line-height:20px;
        opacity:0.11;
    }
}
</style>